import axios from 'axios';

import { UnauthorizedType } from '../types/UnauthorizedType';
import { MessageResultType } from '../types/MessageResultType';

type SuccessType = {
  success: boolean;
  message: string;
  data: MessageResultType;
};

type PromiseType =
  | { data: SuccessType; success: boolean }
  | { data: UnauthorizedType; success: boolean }
  | { data: null; success: boolean };

const POST_FILE = async (data: FormData): Promise<PromiseType> => {
  try {
    const serverUrl = process.env.REACT_APP_SERVER_URL_BACKEND_API;
    if (!serverUrl) throw Error('Backend-URL not defined.');

    const url = `${serverUrl}/generate/submit-file`;

    const response = await axios.post<SuccessType | UnauthorizedType>(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      withCredentials: true,
    });

    if (response.data.success) {
      return { success: true, data: response.data };
    }

    return { success: false, data: response.data };
  } catch (error) {
    console.error(error);

    return { success: false, data: null };
  }
};

export default POST_FILE;
